import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Customer } from '../dto/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private apiUrl = environment.apiRoot + '/customer';

  constructor(private http: HttpClient) { }

  getAllCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.apiUrl + '/allofuser');
  }

  createCustomer(): Observable<Customer> {
    let model = { "id": 0, "name": "new customer" };
    return this.http.post<Customer>(this.apiUrl + '/new', model);
  }

  updateCustomer(model: Customer): Observable<Customer> {
    return this.http.put<Customer>(this.apiUrl + '/update', model);
  }

  deleteCustomer(customerId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?customerId=' + customerId);
  }

}
